import { DISABLED_WHITE_LABEL_PRODUCTS } from 'consts/quote-bind';
import { useApi } from 'hooks';
import api from 'lib/quoteBind/quoteBind.api';

async function getProducts(token) {
  const response = await api(token).get('products');
  const filteredProducts = response?.data?.data?.filter((product) => !DISABLED_WHITE_LABEL_PRODUCTS.includes(product.value)) || [];
  return { ...response.data, data: filteredProducts };
}

export function useGetProducts(queryKey, params, options) {
  return useApi([queryKey], async (_, token) => await getProducts(token), {
    ...options,
    cacheTime: 1000 * 60 * 60 * 24,
  });
}

async function getRiskProductsWithReports(token) {
  const response = await api(token).get('products/reports');

  const filteredProducts = response.data?.data?.filter((product) => !DISABLED_WHITE_LABEL_PRODUCTS.includes(product.value)) || [];
  return filteredProducts;
}
export function useGetProductsWithReports(queryKey, params, options) {
  return useApi([queryKey, { ...params }], async (_, token) => await getRiskProductsWithReports(token), {
    ...options,
    cacheTime: 1000 * 60 * 60 * 24,
  });
}

// getRiskDefinitions
async function getRiskDefinitions(type, token) {
  if (!type) {
    throw new Error('useGetRiskDefinitions: Missing required parameters.');
  }

  const response = await api(token).get(`products/${type}`);

  return response.data;
}

export function useGetRiskDefinitions(queryKey, type, options) {
  return useApi([queryKey, type], async (_, token) => await getRiskDefinitions(type, token), {
    ...options,
  });
}
